import React from 'react';


import { CSSTransition } from 'react-transition-group';
import { range } from 'lodash-es';
import LoadingLogo from './common/LoadingLogo'

import { history } from '../history'

import {
  AppleSvg,
  AndroidSvg,
  NeuroFitNamedLogoSvg,
  InstagramSvg,
  LinkedInSvg,
} from '../constants/svgs'

import {
  subdomainUrls,
  recordLinkClickGA,
  ProductionAboutLorenBaseUrl,
  NeuroFitUniversalAppStoreLink,
  NeuroFitAppleAppStoreLink,
  NeuroFitGooglePlayStoreLink,
  NeuroFitInstagramLink,
  NeuroFitLinkedInLink,
  LorenInstagramLink,
  LorenLinkedInLink,
  recordLinkClickAndRedirect,
  BlogSomaticExercisesWeightLossUrl,
  BlogSomaticExercisesTraumaUrl,
  BlogSomaticExercisesSleepUrl,
  BlogSomaticExercisesAngerUrl,
  BlogDorsalVagalRegulationUrl,
  BlogNervousSystemCoachUrl,
  ProductionLegalTermsOfServiceUrl,
  ProductionLegalPrivacyPolicyUrl,
  getCurrentYear,
} from '../utils'

import {
  GA_LABEL_CLICKED_APP_DOWNLOAD_LINK,
} from '../constants/gaEventLabels'

import QrCodeDownloadModal from './modals/QrCodeDownloadModal'
import DownloadButtonsSection from './common/DownloadButtonsSection'
import WebsiteFooterSection from './common/WebsiteFooterSection'

import Helmet from './common/Helmet'

const containerStyle = {textAlign: "start", height: "100%", width: "100vw", overflowX: "hidden", overflowY: "scroll"}


class LorenAuthorPage extends React.Component {
  constructor(props){
     super(props)
     this.state = {
        learnMoreRef: React.createRef(),
        headerColor: "transparent",
        dropShadowColor: "transparent",
        show: true,
        showIframe: false,
        showQrCodeModal: false
     }
  }

  handleOnClickLearnMore = (event) => {
      //.current is verification that your element has rendered
      if(this.state.learnMoreRef.current){
          this.state.learnMoreRef.current.scrollIntoView({ 
             behavior: "smooth", 
             block: "nearest"
          })
      }
  }

  updateHeaderColorOnContainerScroll = e => {
    if (e.target.scrollTop > 0) {
      const alpha = Math.min(0.5, e.target.scrollTop / 500)
      const headerColor = `rgba(255, 255, 255, ${alpha/1.5})`
      const dropShadowColor = `rgba(0, 0, 0, ${alpha/3.0})`
      this.setState({headerColor, dropShadowColor/* `rgba(53, 63, 106, ${alpha}`*/})
    } else {
      this.setState({headerColor: "transparent", dropShadowColor: "transparent"})
    }

    if (e.target.scrollTop > 400) {
      this.setState({showIframe: true})
    }
  }

  componentDidMount() {
    this.setState({show: true})
    this.scrollingContainerRef.addEventListener('scroll', this.updateHeaderColorOnContainerScroll)
  }

  render() {

    const {
      safeAreaInsets,
      innerHeight,
      formFields,
      isNative,
      isIOSDevice,
      isAndroidDevice,
    } = this.props

    const {show, learnMoreRef, scrollingContainerRef, headerColor, dropShadowColor, showQrCodeModal, showIframe} = this.state

    const currentYear = getCurrentYear()

    const appDownloadUrl = isIOSDevice ? NeuroFitAppleAppStoreLink : (isAndroidDevice ? NeuroFitGooglePlayStoreLink : NeuroFitUniversalAppStoreLink)

    return (
      <div style={{height: innerHeight}}>
        <Helmet
          title={"About Loren Hogue - Co-CEO NEUROFIT"}
          description={"Loren Hogue is the Co-CEO of NEUROFIT - a leading nervous system tech company revolutionizing global stress and burnout relief."}
          href={ProductionAboutLorenBaseUrl}
        />
        <div style={{position: "fixed", left: 0, top: 0, height: innerHeight, overflow: "hidden", backgroundColor: "#EDEEF2"}}>
          <div style={{position: "fixed", top: 0, left: 0, right: 0, height: safeAreaInsets.top, backgroundColor: "#000000", zIndex: 2000}} />
          <div style={{position: "fixed", top: 0, left: 0, right: 0, boxShadow: "0px 2px 0px 0px black", display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12 + safeAreaInsets.top, paddingInlineStart: "min(40px, 7.5%)", paddingInlineEnd: "min(20px, 4%)", paddingBottom: 12, backgroundColor: "white", zIndex: 1000}}>
            <NeuroFitNamedLogoSvg
              logoSize={"min(4.25vw, 18px)"}
              color={"#000000"}
              onClick={() => window.location = "/"}
            />
            {!isNative && (
              <div style={{display: "flex", alignItems: "center"}}>
                <a
                  href={"/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{fontFamily: "Futura Medium", textDecoration: "none", fontSize: "min(4vw, 15px)", textTransform: "uppercase", color: "#000000", cursor: "pointer"}}
                >
                  {"Home"}
                </a>
              </div>
            )}
          </div>
          <div 
            id={"landing-page-container"}
            className={"disable-scrollbars"}
            ref={elem => this.scrollingContainerRef = elem}
            style={containerStyle}
          >
            <div style={{textAlign: "start", width: "100vw", minHeight: innerHeight}}>
              <div style={{color: "black", width: "100%", display: "flex", justifyContent: "center", alignItems: "top", margin: "calc(60px + 3vh) 0px"}}>
                <div style={{width: "85%", maxWidth: 700}}>
                  <h1 style={{fontSize: "min(8.5vw, 40px)", margin: 0, textTransform: "uppercase", textAlign: "start", fontFamily: "Futura"}}>
                    {"Loren Hogue"}
                  </h1>
                  <h2 style={{fontSize: "min(7vw, 32px)", margin: 0, textTransform: "uppercase", textAlign: "start", fontFamily: "Futura"}}>
                    {"Co-CEO NEUROFIT"}
                  </h2>
                  <h2 style={{fontSize: "min(6vw, 26px)", margin: 0, textTransform: "uppercase", textAlign: "start", fontFamily: "Futura"}}>
                    {"Growth, Brand, Ops"}
                  </h2>
                  <div style={{color: "black", margin: "2vh 0px", width: "100%", display: "flex", justifyContent: "left", alignItems: "center"}}>
                    <img src="/images/founders/loren.jpg" class="author-profile-image" />
                    <a
                      itemprop="sameAs"
                      href={LorenInstagramLink}
                      rel="noreferrer noopener"
                      target="_blank"
                      style={{marginInlineStart: "min(6vw, 26px)", backgroundColor: "#CFD2DD", cursor: "pointer", borderRadius: "5px", height: "min(9vw, 45px)", width: "min(9vw, 45px)", display: "flex", justifyContent: "center", alignItems: "center"}}
                    >
                      <InstagramSvg
                        color={"#7c7e84"}
                        size={"min(5vw, 22px)"}
                      />
                    </a>
                    <a
                      itemprop="sameAs"
                      href={LorenLinkedInLink}
                      rel="noreferrer noopener"
                      target="_blank"
                      style={{marginInlineStart: "min(6vw, 26px)", backgroundColor: "#CFD2DD", cursor: "pointer", borderRadius: "5px", height: "min(9vw, 45px)", width: "min(9vw, 45px)", display: "flex", justifyContent: "center", alignItems: "center"}}
                    >
                      <LinkedInSvg
                        color={"#7c7e84"}
                        size={"min(5vw, 22px)"}
                      />
                    </a>
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Loren Hogue leads growth, brand, and operations as Co-CEO of NEUROFIT, a leading wellness tech company dedicated to reducing stress and burnout with nervous system optimization. Starting her career as a lawyer, Loren's journey took a pivotal turn following the sudden passing of her father in 2011."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Dealing with grief, anxiety, and chronic ailments, she embarked on a 12-year journey exploring various healing modalities. This led her to leave her law career and to become a Master Somatics + Business Coach, supporting thousands of global clients with over 3,000+ hours of coaching experience. Her work has been featured in Forbes, Business Insider, Well+Good, SHAPE, Vogue, Prevention, Thrive Global, and more."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Loren's somatics domain expertise, along with her drive to heal intergenerational trauma and understand the nervous system's role in well-being, resulted in the launch of NEUROFIT in 2022."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Together with her husband Andrew, Loren developed the NEUROFIT app, a neuroscience-based tool designed to help individuals regulate their nervous systems with daily check-ins, biometric measurements, and on-demand exercises."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Loren believes that wellness can be profoundly simple, and that a regulated nervous system is the foundation for a balanced, resilient and joyful life."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"All of this fuels her commitment to helping others achieve optimal well-being. Loren is based in New York City, where she continues to innovate and inspire at NEUROFIT."}
                  </div>
                  <div style={{fontFamily: "Futura Book", marginTop: "2vh", fontSize: "min(5.5vw, 22px)"}}>
                    {"Download the NEUROFIT App here:"}
                  </div>
                  {(isIOSDevice || isAndroidDevice) ? (
                    <div style={{display: "flex", justifyContent: "center"}}>
                      <button
                        style={{display: "flex", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: 32, color: "#ffffff", backgroundColor: "#000000", padding: "18px 15px", border: "none"}}
                        onClick={() => {
                          recordLinkClickGA("Universal App Download Link")
                          window.open(NeuroFitUniversalAppStoreLink, "_blank", "noopener noreferrer nofollow")
                        }}
                      >
                        {isIOSDevice ? (
                          <AppleSvg />
                        ) : (isAndroidDevice ? (
                          <AndroidSvg />
                        ) : null)}
                        <span>
                          {"DOWNLOAD NOW"}
                        </span>
                      </button>
                    </div>
                  ) : (
                    <div>
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <button
                          style={{display: "flex", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: 32, color: "#ffffff", backgroundColor: "#000000", padding: "18px 15px", border: "none"}}
                          onClick={() => {
                            recordLinkClickGA("Universal App Download Link")
                            window.open(NeuroFitAppleAppStoreLink, "_blank", "noopener noreferrer nofollow")
                          }}
                        >
                          <AppleSvg />
                          <span>
                            {"DOWNLOAD IOS"}
                          </span>
                        </button>
                      </div>
                      <div style={{display: "flex", justifyContent: "center"}}>
                        <button
                          style={{display: "flex", alignItems: "top", justifyContent: "center", width: "100%", maxWidth: 400, textAlign: "center", fontFamily: "Futura", fontSize: "min(6vw, 25px)", lineHeight: "min(6vw, 25px)", marginTop: 32, color: "#ffffff", backgroundColor: "#000000", padding: "18px 15px", border: "none"}}
                          onClick={() => {
                            recordLinkClickGA("Universal App Download Link")
                            window.open(NeuroFitGooglePlayStoreLink, "_blank", "noopener noreferrer nofollow")
                          }}
                        >
                          <AndroidSvg />
                          <span>
                            {"DOWNLOAD ANDROID"}
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <WebsiteFooterSection
              safeAreaInsets={safeAreaInsets}
              onOpenAppQrCodeModal={() => this.setState({showQrCodeModal: true})}
              showFoundersSection
            />
          </div>
          <QrCodeDownloadModal
            show={showQrCodeModal}
            onHide={() => this.setState({showQrCodeModal: false})}
            safeAreaInsets={safeAreaInsets}
          />
        </div>
      </div>
    )
  }
}

export default LorenAuthorPage;